import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { BrowserRouter } from "react-router-dom";

const msalInstance = new PublicClientApplication(msalConfig);

// Set default active account on startup
const existingAccounts = msalInstance.getAllAccounts();
if (existingAccounts.length > 0) {
  msalInstance.setActiveAccount(existingAccounts[0]);
}

// Handle Azure AD B2C redirect callback
msalInstance
  .handleRedirectPromise()
  .then((response) => {
    if (response && response.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const currentAccounts = msalInstance.getAllAccounts();
      if (currentAccounts.length > 0) {
        msalInstance.setActiveAccount(currentAccounts[0]);
      }
    }
  })
  .catch((err) => {
    console.error("MSAL Redirect Error:", err);
  });

const root = ReactDOM.createRoot(document.getElementById("app"));

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();
